import { gql } from '@apollo/client'

const DISCOUNT_RULE_FIELDS = gql`
  fragment DiscountRuleFields on DiscountRule {
    id
    name
    active
    discount_class
    effect_type
    effect_value
    multi_buy_qty
    scope_type
    scope_value_json
    allocation
    trigger_type
    min_staff_role
    priority
    conditions {
      type
      value_json
    }
    limit {
      max_uses_total
      max_per_order
      starts_at
      ends_at
    }
    codes {
      id
      code
      description
      active
      max_uses
      expires_at
    }
  }
`

export const GET_DISCOUNT_RULES = gql`
  ${DISCOUNT_RULE_FIELDS}
  query GetDiscountRules($active: Boolean, $discount_class: DiscountClass, $trigger_type: DiscountTriggerType) {
    discountRules(active: $active, discount_class: $discount_class, trigger_type: $trigger_type) {
      ...DiscountRuleFields
    }
  }
`

export const GET_DISCOUNT_RULE = gql`
  ${DISCOUNT_RULE_FIELDS}
  query GetDiscountRule($id: Int!) {
    discountRule(id: $id) {
      ...DiscountRuleFields
    }
  }
`

export const GET_DISCOUNT_CODES = gql`
  query GetDiscountCodes($rule_id: Int!, $active: Boolean, $search: String) {
    discountCodes(rule_id: $rule_id, active: $active, search: $search) {
      id
      code
      description
      active
      max_uses
      expires_at
      created_at
    }
  }
`

export const VALIDATE_COUPON = gql`
  query ValidateCoupon($code: String!, $order_total_cents: Int!, $order_type: String!) {
    validateCoupon(code: $code, order_total_cents: $order_total_cents, order_type: $order_type) {
      id
      name
      effect_type
      effect_value
      discount_class
      scope_type
      scope_value_json
      allocation
    }
  }
`

export const PREVIEW_DISCOUNT = gql`
  query PreviewDiscount(
    $lines: [PreviewDiscountLineInput!]!
    $total: Int!
    $code: String
    $type: String!
    $loyalty: LoyaltyCheckoutInput
  ) {
    previewDiscount(
      order_lines: $lines
      order_total_cents: $total
      coupon_code: $code
      order_type: $type
      loyalty: $loyalty
    ) {
      discount_amount_cents
      discounted_total_cents
      product_discount_cents
      product_discount_name
      order_discount_cents
      order_discount_name
      coupon_applied
      coupon_message
      loyalty_reward_cents
      loyalty_reward_name_nl
      loyalty_reward_name_en
      loyalty_message
    }
  }
`
